import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import Flex, { ALIGN_CLASS, DIRECTION_CLASS, GAP_CLASS } from "components/Flex";
import { modalTypes } from "constants/types";
import ProposalRow from "layout/proposals/SectionStatusWidget/components/ProposalRow";
import SectionStatusColumnHeaders from "layout/proposals/SectionStatusWidget/components/SectionStatusColumnHeaders";
import SectionStatusLegend from "layout/proposals/SectionStatusWidget/components/SectionStatusLegend";
import { SUBTITLE, TITLE } from "layout/proposals/SectionStatusWidget/constants";
import { arrayOf, number, shape, string } from "prop-types";
import React from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import {
  exportSectionStatusCsv,
  exportSectionStatusPdf,
} from "slices/sectionStatus";

import styles from "./SectionStatusModal.module.scss";

const SectionStatusModal = ({ proposals }) => {
  const dispatch = useDispatch();
  const isEmpty = proposals.length === 0;

  const onDismiss = () => {
    dispatch(hideModal(modalTypes.SECTION_STATUS));
  };

  return (
    <Modal
      backdrop
      centered
      className={`fade-in ${styles.modal}`}
      onDismiss={onDismiss}
      show
      size="lg"
    >
      <Modal.Header>{TITLE}</Modal.Header>
      <Modal.Body>
        <Flex
          direction={DIRECTION_CLASS.column}
          className={styles.sectionStatusModal}
          alignItems="flex-start"
        >
          <p className={styles.sectionStatusModal__subHeader}>{SUBTITLE}</p>

          <SectionStatusLegend />

          <Flex
            alignItems={ALIGN_CLASS.stretch}
            direction={DIRECTION_CLASS.column}
            gap={GAP_CLASS.GAP_100}
            className={styles.sectionStatusModal__list}
          >
            <SectionStatusColumnHeaders />

            <div className={styles.sectionStatusModal__rowsWrapper}>
              <Flex
                as="ul"
                aria-label="All proposals by section status"
                direction={DIRECTION_CLASS.column}
                className={styles.sectionStatusModal__rows}
              >
                {proposals.map((proposal) => (
                  <ProposalRow
                    key={proposal.proposalId}
                    proposal={proposal}
                    onNavigate={onDismiss}
                  />
                ))}
              </Flex>
            </div>
          </Flex>
        </Flex>
      </Modal.Body>
      <Modal.Footer>
        <NewButton
          disabled={isEmpty}
          onClick={() => dispatch(exportSectionStatusCsv())}
          variant={NewButtonVariant.l2}
        >
          Export CSV
        </NewButton>
        <NewButton
          disabled={isEmpty}
          onClick={() => dispatch(exportSectionStatusPdf())}
          variant={NewButtonVariant.l1}
        >
          Export PDF
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

SectionStatusModal.propTypes = {
  proposals: arrayOf(
    shape({
      proposalId: number.isRequired,
      proposalName: string.isRequired,
      dueDate: arrayOf(number),
      notStarted: number.isRequired,
      drafting: number.isRequired,
      inReview: number.isRequired,
      complete: number.isRequired,
    })
  ).isRequired,
};

export default SectionStatusModal;
